export const accessCategoryTypes = {
    loading: "LOADING_ACCESSCATEGORY",
    delete: "DELETE_ACCESSCATEGORY",
    loadedOne: "LOADED_ACCESSCATEGORY",
    loadedMultiple: "LOADED_ACCESSCATEGORYS",
    success: "SUCCESS_ACCESSCATEGORY",
    restore: "RESTORE_ACCESSCATEGORY",
    hardDelete: "HARDDELETE_ACCESSCATEGORY",
};
